if (!customElements.get('acdc-locations-grid')) {
  class ACDCLocationsGrid extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('[role="tab"]');
      this.panels = this.querySelectorAll('[role="tabpanel"]');
      this.perPage = parseInt(this.dataset.perPage, 10) || 8;
      this.currentPages = {};

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab));
      });

      if (this.tabs.length > 0) {
        this.activateTab(this.tabs[0]);
      }

      this.resizeObserver = new ResizeObserver(() => this.handleResize());
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    activateTab(tab) {
      const index = tab.dataset.index;

      this.tabs.forEach((t) => {
        t.setAttribute('aria-selected', 'false');
        t.classList.remove('is-active');
      });
      this.panels.forEach((p) => p.setAttribute('hidden', ''));

      tab.setAttribute('aria-selected', 'true');
      tab.classList.add('is-active');

      const panel = this.panels[index];
      if (panel) {
        panel.removeAttribute('hidden');
        if (!this.currentPages[index]) this.currentPages[index] = 0;
        this.paginatePanel(panel, index);
      }
    }

    isMobile() {
      return window.innerWidth < 768;
    }

    paginatePanel(panel, tabIndex) {
      const cards = panel.querySelectorAll('.locations-grid__card');
      const totalCards = cards.length;

      if (this.isMobile() || totalCards <= this.perPage) {
        cards.forEach((card) => card.removeAttribute('hidden'));
        this.hidePagination(panel);
        return;
      }

      const totalPages = Math.ceil(totalCards / this.perPage);
      const page = this.currentPages[tabIndex] || 0;

      cards.forEach((card, i) => {
        const cardPage = Math.floor(i / this.perPage);
        if (cardPage === page) {
          card.removeAttribute('hidden');
        } else {
          card.setAttribute('hidden', '');
        }
      });

      this.renderPagination(panel, tabIndex, page, totalPages);
    }

    renderPagination(panel, tabIndex, currentPage, totalPages) {
      let pagination = panel.querySelector('.locations-grid__pagination');

      if (!pagination) {
        pagination = document.createElement('div');
        pagination.className = 'locations-grid__pagination';
        panel.appendChild(pagination);
      }

      pagination.innerHTML = '';

      const prevBtn = document.createElement('button');
      prevBtn.className = 'locations-grid__pagination-arrow';
      prevBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
      prevBtn.disabled = currentPage === 0;
      prevBtn.setAttribute('aria-label', 'Previous page');
      prevBtn.addEventListener('click', () => {
        if (this.currentPages[tabIndex] > 0) {
          this.currentPages[tabIndex]--;
          this.paginatePanel(panel, tabIndex);
        }
      });

      const dotsContainer = document.createElement('div');
      dotsContainer.className = 'locations-grid__pagination-dots';

      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('button');
        dot.className = 'locations-grid__pagination-dot';
        if (i === currentPage) dot.classList.add('is-active');
        dot.setAttribute('aria-label', `Page ${i + 1}`);
        dot.addEventListener('click', () => {
          this.currentPages[tabIndex] = i;
          this.paginatePanel(panel, tabIndex);
        });
        dotsContainer.appendChild(dot);
      }

      const nextBtn = document.createElement('button');
      nextBtn.className = 'locations-grid__pagination-arrow';
      nextBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
      nextBtn.disabled = currentPage === totalPages - 1;
      nextBtn.setAttribute('aria-label', 'Next page');
      nextBtn.addEventListener('click', () => {
        if (this.currentPages[tabIndex] < totalPages - 1) {
          this.currentPages[tabIndex]++;
          this.paginatePanel(panel, tabIndex);
        }
      });

      pagination.appendChild(prevBtn);
      pagination.appendChild(dotsContainer);
      pagination.appendChild(nextBtn);
    }

    hidePagination(panel) {
      const pagination = panel.querySelector('.locations-grid__pagination');
      if (pagination) pagination.remove();
    }

    handleResize() {
      const activeTab = this.querySelector('[role="tab"].is-active');
      if (activeTab) {
        const index = activeTab.dataset.index;
        const panel = this.panels[index];
        if (panel && !panel.hasAttribute('hidden')) {
          this.paginatePanel(panel, index);
        }
      }
    }
  }

  customElements.define('acdc-locations-grid', ACDCLocationsGrid);
}
